export default {
  fa: {
    copyTitle: 'متن بخش پزشکان',
    copyHint: 'این متن\u200cها برای همهٔ بخش\u200cهای پزشکان در زبان انتخاب\u200cشده نمایش داده می\u200cشوند. متن خالی، متن پیش\u200cفرض را برمی\u200cگرداند. از معرفی پزشکان به\u200cعنوان متخصص این موضوع بدون بررسی ارتباط آن\u200cها خودداری کنید.',
    copyEyebrow: 'متن کوتاه بالای عنوان',
    copyHeading: 'عنوان بخش',
    copyIntro: 'توضیح زیر عنوان',
    defaults: 'پزشکان پیش‌فرض',
    defaultsHint: 'می‌توانید تا سه پزشک به مجموعهٔ انتخاب خودکار اضافه کنید. اگر قانون یا پزشک مرتبطی پیدا نشود، از این مجموعه و پزشکان انتخاب‌شده برای مطالب دیگر استفاده می‌شود. انتخاب و ترتیب نمایش خودکار ممکن است تغییر کند؛ ترتیب انتخاب دستی و قوانین ثابت می‌ماند.',
    defaultSource: 'پزشکان پیش‌فرض انتخاب‌شده',
    generalSource: 'انتخاب خودکار پزشکان',
    discard: 'لغو تغییرات',
    title: 'پزشکان مطالب',
    intro: 'پزشکان به‌صورت خودکار کنار مطالب نمایش داده می‌شوند. اینجا می‌توانید انتخاب‌ها را برای گروهی از مطالب تغییر دهید.',
    language: 'زبان محتوا',
    enabled: 'نمایش خودکار پزشکان',
    enabledHint: 'انتخاب اختصاصی هر مطلب مستقل از این گزینه است.',
    count: 'حداکثر تعداد پزشکان',
    placement: 'محل نمایش پیش‌فرض',
    middle: 'میان متن',
    end: 'پایان مطلب',
    rules: 'انتخاب پزشکان برای گروهی از مطالب',
    rulesHint: 'اولین قانون مطابق از بالای فهرست اجرا می‌شود. اگر قانونی مطابق نبود، پزشکان با برچسب مشترک نمایش داده می‌شوند.',
    add: 'افزودن قانون',
    name: 'نام قانون',
    active: 'فعال',
    remove: 'حذف قانون',
    up: 'بالاتر',
    down: 'پایین‌تر',
    targets: 'این قانون برای کدام مطالب است؟',
    articles: 'مطلب‌های مشخص',
    tags: 'برچسب‌ها',
    categories: 'دسته‌بندی‌ها',
    keywords: 'کلمه‌های عنوان یا متن',
    keywordHint: 'هر کلمه یا عبارت را در یک خط بنویسید؛ حداکثر ۱۰ عبارت.',
    matching: 'در هر گروه، وجود یکی از انتخاب‌ها کافی است. اگر چند گروه را پر کنید، مطلب باید با همهٔ آن گروه‌ها مطابق باشد.',
    more: 'شرط‌های بیشتر',
    save: 'ذخیره تنظیمات',
    saving: 'در حال ذخیره…',
    loading: 'در حال دریافت…',
    saved: 'تنظیمات ذخیره شد.',
    failed: 'دریافت یا ذخیره تنظیمات انجام نشد. دوباره تلاش کنید.',
    conflict: 'تنظیمات توسط شخص دیگری تغییر کرده است. صفحه را دوباره بارگذاری کنید و تغییرات را بررسی کنید.',
    invalid: 'برای هر قانون، نام، حداقل یک شرط و یک تا سه پزشک انتخاب کنید. محدودیت تعداد انتخاب‌ها را هم بررسی کنید.',
    preview: 'پیش‌نمایش انتخاب پزشکان',
    previewHint: 'پیش‌نمایش از تنظیمات و مطلب ذخیره‌شده استفاده می‌کند. انتخاب خودکار با تغییر مطلب یا روز ممکن است فرق کند.',
    previewButton: 'دیدن نتیجه',
    none: 'برای این مطلب پزشکی نمایش داده نمی‌شود.',
    automatic: 'بر اساس برچسب مشترک',
    manual: 'انتخاب اختصاصی مطلب',
    rule: 'بر اساس قانون',
    disabled: 'نمایش غیرفعال است',
    empty: 'هنوز قانونی اضافه نشده؛ ابتدا پزشکان مرتبط با برچسب مطلب و سپس پزشکان پیش‌فرض یا پزشکان انتخاب‌شده برای مطالب دیگر نمایش داده می‌شوند.',
    noWrite: 'شما دسترسی تغییر این تنظیمات را ندارید.',
    unsaved: 'تغییرات ذخیره نشده‌اند.',
  },
  en: {
    copyTitle: 'Doctor block text',
    copyHint: 'These texts appear in all doctor blocks for the selected content language. Leave a field empty to restore its default. Use general wording unless the doctors’ relevance to the topic has been verified.',
    copyEyebrow: 'Text above the heading',
    copyHeading: 'Block heading',
    copyIntro: 'Text below the heading',
    defaults: 'Default doctors',
    defaultsHint: 'Add up to three doctors to the automatic selection pool. When no rule or related doctor matches, this pool also includes doctors selected for other content. Automatic selections and their order may vary; manual selections and rule order stay fixed.',
    defaultSource: 'Selected default doctors',
    generalSource: 'Automatic doctor selection',
    discard: 'Discard changes',
    title: 'Content doctors',
    intro: 'Doctors appear automatically with content. Use rules to choose doctors for groups of posts.',
    language: 'Content language',
    enabled: 'Show doctors automatically',
    enabledHint: 'Individual content selections work independently of this setting.',
    count: 'Maximum doctors',
    placement: 'Default placement',
    middle: 'Within the content',
    end: 'After the content',
    rules: 'Choose doctors for groups of posts',
    rulesHint: 'The first matching rule wins. When no rule matches, doctors with shared topic tags are selected.',
    add: 'Add rule',
    name: 'Rule name',
    active: 'Enabled',
    remove: 'Remove rule',
    up: 'Move up',
    down: 'Move down',
    targets: 'Which posts should match?',
    articles: 'Specific posts',
    tags: 'Tags',
    categories: 'Categories',
    keywords: 'Words in the title or content',
    keywordHint: 'One word or phrase per line; up to 10 phrases.',
    matching: 'Any choice within a group can match. When several groups are filled, the post must match every filled group.',
    more: 'More conditions',
    save: 'Save settings',
    saving: 'Saving…',
    loading: 'Loading…',
    saved: 'Settings saved.',
    failed: 'Settings could not be loaded or saved. Please try again.',
    conflict: 'Someone else changed these settings. Reload the page and review the changes.',
    invalid: 'Each rule needs a name, at least one condition and one to three doctors. Check the selection limits too.',
    preview: 'Preview doctor selection',
    previewHint: 'Preview uses saved settings and the saved post. Automatic selections may vary by post and day.',
    previewButton: 'Show result',
    none: 'No doctor block will appear for this post.',
    automatic: 'Shared topic tags',
    manual: 'Individual content selection',
    rule: 'Matching rule',
    disabled: 'Display is disabled',
    empty: 'No rules yet. Shared topic tags are checked first, then default doctors or doctors selected for other content.',
    noWrite: 'You do not have permission to change these settings.',
    unsaved: 'There are unsaved changes.',
  },
  ar: {
    copyTitle: 'نص قسم الأطباء',
    copyHint: 'تظهر هذه النصوص في جميع أقسام الأطباء بلغة المحتوى المختارة. اترك الحقل فارغًا لاستعادة النص الافتراضي. استخدم صياغة عامة ما لم يتم التحقق من صلة الأطباء بالموضوع.',
    copyEyebrow: 'النص فوق العنوان',
    copyHeading: 'عنوان القسم',
    copyIntro: 'النص تحت العنوان',
    defaults: 'الأطباء الافتراضيون',
    defaultsHint: 'يمكن إضافة ثلاثة أطباء كحد أقصى إلى مجموعة الاختيار التلقائي. عندما لا تتطابق أي قاعدة ولا يُعثر على طبيب مرتبط بالموضوع، تشمل المجموعة أيضًا الأطباء المختارين لمحتوى آخر. قد يتغير الاختيار التلقائي وترتيب العرض؛ يبقى ترتيب الاختيارات اليدوية والقواعد ثابتًا.',
    defaultSource: 'الأطباء الافتراضيون المختارون',
    generalSource: 'اختيار الأطباء تلقائيًا',
    discard: 'إلغاء التغييرات',
    title: 'أطباء المحتوى',
    intro: 'يظهر الأطباء تلقائيًا مع المحتوى. يمكنكم تحديد الأطباء لمجموعات من المقالات هنا.',
    language: 'لغة المحتوى',
    enabled: 'عرض الأطباء تلقائيًا',
    enabledHint: 'الاختيارات الخاصة بكل محتوى مستقلة عن هذا الإعداد.',
    count: 'العدد الأقصى للأطباء',
    placement: 'موضع العرض الافتراضي',
    middle: 'داخل المحتوى',
    end: 'بعد المحتوى',
    rules: 'اختيار الأطباء لمجموعات من المقالات',
    rulesHint: 'تُطبّق أول قاعدة مطابقة من أعلى القائمة. إذا لم تطابق أي قاعدة، يُختار الأطباء حسب الوسوم المشتركة.',
    add: 'إضافة قاعدة',
    name: 'اسم القاعدة',
    active: 'مفعّلة',
    remove: 'حذف القاعدة',
    up: 'نقل لأعلى',
    down: 'نقل لأسفل',
    targets: 'ما المحتوى الذي تنطبق عليه القاعدة؟',
    articles: 'محتوى محدد',
    tags: 'الوسوم',
    categories: 'التصنيفات',
    keywords: 'كلمات في العنوان أو النص',
    keywordHint: 'كلمة أو عبارة في كل سطر؛ حتى ١٠ عبارات.',
    matching: 'تكفي مطابقة اختيار واحد داخل كل مجموعة. عند تعبئة عدة مجموعات، يجب أن يطابق المحتوى كل مجموعة منها.',
    more: 'شروط إضافية',
    save: 'حفظ الإعدادات',
    saving: 'جارٍ الحفظ…',
    loading: 'جارٍ التحميل…',
    saved: 'تم حفظ الإعدادات.',
    failed: 'تعذّر تحميل الإعدادات أو حفظها. يرجى المحاولة مجددًا.',
    conflict: 'عدّل شخص آخر هذه الإعدادات. أعيدوا تحميل الصفحة وراجعوا التغييرات.',
    invalid: 'تحتاج كل قاعدة إلى اسم وشرط واحد على الأقل وطبيب واحد إلى ثلاثة أطباء. راجعوا حدود الاختيارات أيضًا.',
    preview: 'معاينة اختيار الأطباء',
    previewHint: 'تستخدم المعاينة الإعدادات والمحتوى المحفوظين. قد يتغير الاختيار التلقائي مع اختلاف المقال أو اليوم.',
    previewButton: 'عرض النتيجة',
    none: 'لن يظهر قسم الأطباء لهذا المحتوى.',
    automatic: 'وسوم الموضوع المشتركة',
    manual: 'اختيار خاص بالمحتوى',
    rule: 'القاعدة المطابقة',
    disabled: 'العرض معطّل',
    empty: 'لا توجد قواعد بعد. يتم البحث حسب الوسوم المشتركة أولًا، ثم الأطباء الافتراضيين أو الأطباء المختارين لمحتوى آخر.',
    noWrite: 'ليس لديكم إذن لتغيير هذه الإعدادات.',
    unsaved: 'توجد تغييرات غير محفوظة.',
  },
}
